import { X } from 'lucide-react'

import { Badge } from '@/components/ui/badge'

import { useEconomicCycleById } from '../../hooks/useFilterOptionsData'

interface EconomicCycleBadgeProps {
  cycleId: string
  onRemove: () => void
}

export const EconomicCycleBadge = ({
  cycleId,
  onRemove,
}: EconomicCycleBadgeProps) => {
  const { economicCycleLabel } = useEconomicCycleById(cycleId)

  return (
    <Badge
      className="flex items-center gap-1 bg-gray-200 text-gray-800 hover:bg-gray-300"
      variant="default"
    >
      <span>{economicCycleLabel || `Ciclo: ${cycleId}`}</span>
      <X className="h-3 w-3 cursor-pointer" onClick={onRemove} />
    </Badge>
  )
}
